import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { hotPicksIds } from '@/mocks/works';
import { getWorkById, typeLabel } from '@/utils/works';

export default function HotPicks() {
  const picks = hotPicksIds
    .map((id) => getWorkById(id))
    .filter((w): w is NonNullable<typeof w> => Boolean(w));

  return (
    <section className="px-4 md:px-8 py-10 md:py-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="热门推荐合集"
          subtitle="编辑精挑细选，口碑与热度兼具的佳作"
          icon="ri-fire-line"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {picks.map((work, i) => (
            <Link
              key={work.id}
              to={`/detail/${work.id}`}
              className="group flex gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="relative w-24 sm:w-28 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
                <img
                  src={work.cover}
                  alt={`${work.title} 封面`}
                  title={`${work.title} 热门推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-1.5 left-1.5 w-6 h-6 rounded-md bg-accent-500 text-secondary-950 text-xs font-bold flex items-center justify-center">
                  {i + 1}
                </span>
              </div>

              <div className="flex-1 min-w-0 flex flex-col">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {work.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800">
                    {typeLabel(work.type)}
                  </span>
                </div>
                <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 text-accent-600 font-medium">
                    <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
                    {work.rating.toFixed(1)}
                  </span>
                  <span>{work.year}</span>
                  <span>{work.region}</span>
                  <span className="truncate">{work.genres.join(' / ')}</span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {work.synopsis}
                </p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs text-primary-600 group-hover:text-accent-600 transition-colors">
                  主演：{work.actors.slice(0, 3).join('、')}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}